import * as React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "../../../components/mui";
import Modal from "../../../components/shared/Modal";

/**
 * Expenses Modal Component
 * Displays expense mapping details for an RF
 * Reusable modal consistent with other modals in the application
 */
export default function ExpensesModal({ open, onClose, rfData }) {
  // Hardcoded expenses data - Backend developer will replace with API calls
  const expensesData = [
    {
      type: "Electricity",
      condoUnit: "2368 Mabolo St.",
      paymentFrom: "29/11/2025",
      paymentTo: "28/12/2025"
    }
  ];

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Expenses"
      maxWidth="md"
      fullWidth
    >
      <TableContainer component={Paper} className="modal-table-container">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell className="modal-table-header">Type</TableCell>
              <TableCell className="modal-table-header">Condo Unit</TableCell>
              <TableCell className="modal-table-header">Payment From</TableCell>
              <TableCell className="modal-table-header">Payment To</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {expensesData.map((expense, index) => (
              <TableRow key={index}>
                <TableCell className="modal-table-cell">{expense.type}</TableCell>
                <TableCell className="modal-table-cell">{expense.condoUnit}</TableCell>
                <TableCell className="modal-table-cell">{expense.paymentFrom}</TableCell>
                <TableCell className="modal-table-cell">{expense.paymentTo}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Modal>
  );
}
